




























































































































import Vue from 'vue';
import config from '../../config/index';
import { RegistroInterface } from '../../interfaces/Login';
import { Component, Watch } from 'vue-property-decorator';
import { ServicioProxy, EstadoEntidad } from '@/config/enums';
import HandleErrors from '../../config/handleErrors';
import ValidaRut from '../../config/validaRut';
import { Validator } from 'vee-validate';
import { AxiosVue } from '@/AxiosVue';

@Component
export default class Registro extends Vue {
  $snotify: any;
  userData: RegistroInterface = {};
  validForm: boolean = false;
  dictionaryFormErrors: any = {};
  confirmPass: string = '';
  handleErrors: HandleErrors = new HandleErrors();
  vr: ValidaRut = new ValidaRut();
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  registro() {
    this.$validator.validateAll().then(res => {
      if (res) {
        let model = {
          Id: 0,
          NombreUsuario: this.userData.email,
          Nombre: this.userData.nombre,
          ApellidoPaterno: this.userData.apellidoPaterno,
          ApellidoMaterno: this.userData.apellidoMaterno,
          Rut: this.userData.rut,
          Email: this.userData.email,
          Direccion: this.userData.direccion,
          Telefono: this.userData.telefono,
          Contrasena: this.userData.contrasena,
          FechaNacimiento: this.userData.fechaNacimiento,
        };

        var he = this.handleErrors;

        this.axios.http
          .post('usuario', model)
          .then(response => {
            var r = this.$router;
            this.$snotify.success('Registro Correcto');

            setTimeout(function() {
              r.replace('/login');
            }, 1500);
          })
          .catch(function(error) {
            he.showError(error);
          });
      }
    });
  }

  created() {
    var r = this.vr;
    Validator.extend('rut', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.Rut(value),
            data: r.Rut(value) ? undefined : { message: '* Rut inválido' },
          });
        });
      },
    });

    this.dictionaryFormErrors = {
      custom: {
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        rut: {
          required: () => config.errorMensajes.textoRequerido,
        },
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
        },
        apellidoMaterno: {
          required: () => config.errorMensajes.textoRequerido,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
}
